<template>
    <div>
        <div class="row">
            <div class="col-12 col-lg-6 mb-3">
                <h1>Normas</h1>
            </div> 
            <div class="col-12 col-lg-6 mb-3 d-flex flex-row justify-content-end align-items-end">
                <!-- TODO: Replace this in a toolbar option -->
                <!-- <label for="content_id" class="e-control e-btn e-lib e-primary mb-0 mr-3">
                    Sin contenido <input type="checkbox" id="content_id" v-model="check" @change="getRules()" class="badgebox">
                    <span class="badge">&check;</span>
                </label> -->

                <ejs-button v-if="$validPermission('CLI-CLIUSERADD')" type='button' cssClass='e-primary mr-3' @click.native="openFormLoadRules">{{ $t('textDetailRule.loadRule') }}</ejs-button>
                
                <!-- TODO: Export to excel -->
                <!-- <ejs-button
                    v-if="$validPermission('FEEDER-EXPORTNORMEXCEL');"
                    cssClass='e-export-excel mr-3'
                    :disabled="isGenerating"
                >
                    {{ isGenerating ? $t('textReports.btnGenerating_report') : $t('textReports.btnTextExportExcel') }}
                </ejs-button> -->

                <ejs-button @click.native="openNewNormForm">Nueva norma</ejs-button>
            </div>
        </div> 

        <normSearch />
        
    </div>
</template>

<script>

import normSearch from '../search/normSearch.vue';

export default   {
    name :"list-rules",
    components: {
        'normSearch': normSearch,
    },
    data() {
        return {
            isGenerating: false,
        }
    },
    methods: {
        openNewNormForm() {
            Vue.prototype.$eventHub.$emit('toggleSidebarClick', 'Nueva norma', 'add-rule', {}, false);
        },
        openFormLoadRules: function () {
            this.$router.push({ name: 'load-file-rules' });
        }
    }
}
</script>